// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => CustomerRequestStatus.loadInternal(), entryList => {
        CustomerRequestStatus.θentryList.set(entryList)
        CustomerRequestStatus.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class CustomerRequestStatus {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<CustomerRequestStatus.Id | null>;
    static readonly Id = String;
    static ids: CustomerRequestStatus.Id[] = [] as any;
    static idsAndDisplayValues: Record<CustomerRequestStatus.Id, string> = {} as any;
    static θentryList = signal<CustomerRequestStatus.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<CustomerRequestStatus.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? CustomerRequestStatus.getEntryMap()[id]?.label : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return CustomerRequestStatus[BoInfoSymbol]
    }

    get __type(): 'Orders.CustomerRequestStatus' {
        return 'Orders.CustomerRequestStatus'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.CustomerRequestStatus' {
        return 'Orders.CustomerRequestStatus'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): CustomerRequestStatus.Id | null {
        return this.θid()
    }

    set id(id: CustomerRequestStatus.Id | CustomerRequestStatus | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !CustomerRequestStatus.getEntry(id as CustomerRequestStatus.Id)) throw new Error('Invalid id for type Orders.CustomerRequestStatus: ' + id)
        this.θid.set(id as CustomerRequestStatus.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): CustomerRequestStatus.Id[] {
        return CustomerRequestStatus.ids
    }

    get idsAndDisplayValues(): Record<CustomerRequestStatus.Id, string> {
        return CustomerRequestStatus.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[CustomerRequestStatus.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isNew() {
        return this.id == 'new'
    }

    static get New() {
        return new this('new')
    }

    get isError() {
        return this.id == 'error'
    }

    static get Error() {
        return new this('error')
    }

    get isRequested() {
        return this.id == 'requested'
    }

    static get Requested() {
        return new this('requested')
    }

    get isOfferReceived() {
        return this.id == 'offerReceived'
    }

    static get OfferReceived() {
        return new this('offerReceived')
    }

    get isOffered() {
        return this.id == 'offered'
    }

    static get Offered() {
        return new this('offered')
    }

    get isOrdered() {
        return this.id == 'ordered'
    }

    static get Ordered() {
        return new this('ordered')
    }

    get isClosed() {
        return this.id == 'closed'
    }

    static get Closed() {
        return new this('closed')
    }

    constructor(idOrObject: CustomerRequestStatus.Id | CustomerRequestStatus | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): CustomerRequestStatus.Entry[] {
        return This.CustomerRequestStatus.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): CustomerRequestStatus.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: CustomerRequestStatus.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof CustomerRequestStatus.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = CustomerRequestStatus.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<CustomerRequestStatus.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new CustomerRequestStatus(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: CustomerRequestStatus.Id | CustomerRequestStatus | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as CustomerRequestStatus.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: CustomerRequestStatus.Id | CustomerRequestStatus) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<CustomerRequestStatus.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.CustomerRequestStatus yet:', err.message)
            //throw err
        })
    }

    setNew() {
        this.id = 'new'

    }

    setError() {
        this.id = 'error'

    }

    setRequested() {
        this.id = 'requested'

    }

    setOfferReceived() {
        this.id = 'offerReceived'

    }

    setOffered() {
        this.id = 'offered'

    }

    setOrdered() {
        this.id = 'ordered'

    }

    setClosed() {
        this.id = 'closed'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "new", label: "New" }),
            Object.freeze({ id: "error", label: "Error" }),
            Object.freeze({ id: "requested", label: "Requested from vendor" }),
            Object.freeze({ id: "offerReceived", label: "Vendor offer received" }),
            Object.freeze({ id: "offered", label: "Offered to customer" }),
            Object.freeze({ id: "ordered", label: "Ordered" }),
            Object.freeze({ id: "closed", label: "Closed" })
        ] as CustomerRequestStatus.Entry[]) as CustomerRequestStatus.Entry[]
    }
}
jsonClass('Orders.CustomerRequestStatus')(CustomerRequestStatus)

export const CustomerRequestStatusθId = String;

export type CustomerRequestStatusθId = string;

export namespace CustomerRequestStatus {
    export type Id = 'new' | 'error' | 'requested' | 'offerReceived' | 'offered' | 'ordered' | 'closed'

    export interface Entry {
        id: CustomerRequestStatus.Id;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => CustomerRequestStatus.load(true))
